export const ErrorMessages = {
  "NETWORK_SUBMIT_ERROR": "<b>Network Error</b>: An error occurred while submitting this form. Please try again.",
  "MISSING_FIELDS": "Some questions have been missed. Please answer all required fields indicated with a red * and try again.",
  "NETWORK_RETRIEVAL_ERROR": "<b>Network Error</b>: An error occurred. Please try again.",
  "NUMERIC_ONLY":"Field can only accept numbers only",
  "MISSING_FORM_FIELDS":"Some required fields have been missed. Please answer all fields highlighted in red and try again",
  "EMAIL_DOES_NOT_MATCH":"Email and Confirm Email Does Not Match"
}